module.exports = __webpack_public_path__ + "static/media/logoText.34cff3b3.png";